import { render, staticRenderFns } from "./goodspackdetail.vue?vue&type=template&id=5423ddc6&scoped=true"
import script from "./goodspackdetail.vue?vue&type=script&lang=js"
export * from "./goodspackdetail.vue?vue&type=script&lang=js"
import style0 from "./goodspackdetail.vue?vue&type=style&index=0&id=5423ddc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5423ddc6",
  null
  
)

export default component.exports